// src/utils/badges.js
export function candidateStatusLabel(v){ return v === 1 ? 'Active' : 'Inactive'; }
export function jobStatusLabel(v){ return v === 0 ? 'Cancelled' : (v === 1 ? 'Open' : 'On Hold'); }
export function interviewStatusLabel(v){ return v === 0 ? 'Cancelled' : (v === 1 ? 'Scheduled' : 'Completed'); }
export function hiringDecisionLabel(v){ return v === 1 ? 'HIRE' : 'DO NOT HIRE'; }

export function badge(text, tone='default'){
  const cls = tone === 'ok' ? 'bg-green-100 text-green-800' :
              tone === 'warn' ? 'bg-yellow-100 text-yellow-800' :
              tone === 'bad' ? 'bg-red-100 text-red-800' :
              'bg-gray-100 text-gray-800';
  return `<span class="px-2 py-1 rounded text-xs font-medium ${cls}">${text}</span>`;
}
